//import React from 'react';
import * as React from "react";
//import Grid from '../../components/Grid/Grid';
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import bg from "../../assets/images/estilo-aprendizaje/fondoestiloaprendizaje.png";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import PhotoIcon from "@mui/icons-material/Photo";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import {
  DataGrid,
  GridCallbackDetails,
  GridColDef,
  GridRowSelectionModel,
  GridToolbar,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import axios, { EnpointsUrlBase } from "../../helpers/axios";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import exportFromJSON from "export-from-json";
import { LogoContainer } from "../EstiloAprendizaje/EstiloAprendizajeStyles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@mui/material";
import { Cloud } from "@mui/icons-material";

const columns: GridColDef[] = [
  {
    field: "idUsuario",
    headerName: "ID",
    width: 200,
  },
  {
    field: "nombreUsuario",
    headerName: "Nombre",
    width: 250,
  },
  {
    field: "programa",
    headerName: "Programa",
    width: 250,
  },
  {
    field: "empresa",
    headerName: "Empresa",
    width: 250,
  },
];

//import AddressForm from './AddressForm';
//import PaymentForm from './PaymentForm';
//import Review from './Review';

interface RowsReportType {
  id: string;
  nombreUsuario: string;
  programa: string;
  empresa: string;
  graficoBase64?: string;
  idUsuario: string;
  emailUsuario: string;
}

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://mancosoft.com/">
        www.mancosoft.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function CustomToolbar() {
  return <GridToolbarContainer></GridToolbarContainer>;
}

const ReportsContainer = () => {
  const [fechaInicio, setFechaInicio] = React.useState<Dayjs | null>(
    dayjs().subtract(1, "month")
  );
  const [fechaFin, setFechaFin] = React.useState<Dayjs | null>(dayjs());

  const [fechaInicioToSend, setFechaInicioToSend] = React.useState<
    string | null
  >(dayjs().subtract(1, "month").format("YYYY-MM-DD"));

  const [fechaFinToSend, setFechaFinToSend] = React.useState<string | null>(
    dayjs().format("YYYY-MM-DD")
  );

  const [introspeccion, setIntrospeccion] = React.useState("2");
  const [loading, setLoading] = React.useState(false);
  const [selection, setSelection] = React.useState<GridRowSelectionModel>([]);
  const [programaSelected, setProgramaSelected] = React.useState("");
  const [empresaSelected, setEmpresaSelected] = React.useState("");
  const [usuario, setUsuario] = React.useState("");
  const [exportTo, setExportTo] = React.useState("");
  const [itemsPerPage, setItemsPerPage] = React.useState(10);
  const [pdfGeneratedCount, setPdfGeneratedCount] = React.useState(0);

  const [rows, setRows] = React.useState<Array<RowsReportType>>([]);

  const [initialGridState] = React.useState({
    pagination: {
      paginationModel: {
        pageSize: 10,
      },
    },
  });

  const handleIntrospeccionChange = (event: SelectChangeEvent) => {
    //setAge(event.target.value as string);
    setIntrospeccion(event.target.value.toString());
  };

  //const [value, setValue] = React.useState<Dayjs | null>(
  //    dayjs('2014-08-18T21:11:54'),
  //);

  const handleFechaInicio = (newValue: Dayjs | null) => {
    setFechaInicio(newValue);
    setFechaInicioToSend(newValue ? newValue.format("YYYY-MM-DD") : "");
  };

  const handleFechaFin = (newValue: Dayjs | null) => {
    setFechaFin(newValue);
    setFechaFinToSend(newValue ? newValue.format("YYYY-MM-DD") : "");
  };

  const handleSearch = () => {
    setLoading(true);
    setSelection([]);
    setRows([]);
    getReport();
  };

  const handleDelete = async () => {
    setLoading(true);

    selection.forEach((k, index) => {
      const element = { ...rows.filter((l) => l.id == k)[0] };
      axios.delete(
        `${EnpointsUrlBase}/${getController()}/${k}`,
        null,
        (res: any, data: any) => {
          if (res === 200) {
            const newRows = rows.filter((l) => l.id != k);
            setRows(newRows);
            setLoading(false);
            setOpenModal(false);
          } else {
            setLoading(false);
          }
        }
      );
    });
  };

  const downloadExcelFile = () => {
    setLoading(true);
    const data: any[] = [];

    selection.forEach((k, index) => {
      const element = { ...rows.filter((l) => l.id == k)[0] };
      element.graficoBase64 = undefined;
      data.push(element);
    });

    const fileName = `excel-${programaSelected}-${empresaSelected}-${usuario}(${fechaInicioToSend}/${fechaFinToSend})`;
    const exportType = exportFromJSON.types.xls;

    exportFromJSON({ data, fileName, exportType });
    setLoading(false);
  };

  const downloadGraficosZip = async () => {
    setLoading(true);
    // Create a new JSZip object
    const zip = new JSZip();

    selection.forEach((k, index) => {
      const element = rows.filter((l) => l.id == k)[0];

      if (element.graficoBase64) {
        // Define your base64 image string
        const base64Image = element.graficoBase64;

        // Convert the base64 string to a Blob
        const byteString = atob(base64Image.split(",")[1]);
        const mimeString = base64Image
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const intArray = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
          intArray[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: mimeString });

        // Add the image file to the zip
        zip.file(`(${index}) - ${element.nombreUsuario}.png`, blob);
      }
    });

    // Generate the zip file as a blob
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Use the saveAs function from the file-saver library to download the blob
    saveAs(
      zipBlob,
      `graficos-${programaSelected}-${empresaSelected}-${usuario}(${fechaInicioToSend}/${fechaFinToSend}).zip`
    );
    setLoading(false);
  };
  // id: string;
  //   nombreUsuario: string;
  //   programa: string;
  //   empresa: string;
  //   graficoBase64?: string;
  //   idUsuario: string;
  //   emailUsuario: string;
  const downloadPdfFiles = () => {
    switch (introspeccion) {
      case "1":
        // handleGenerateTestParadigmasPdf(idUsuario, nombreUsuario, empresa);
        break;
      case "2":
        downloadEstiloAprendizajePDFsAsZIP();
        break;
      case "3":
        downloadEstiloNaturalDecisionPDFsAsZIP();
        break;
      case "4":
        downloadFactorCTPDFsAsZIP();
        break;
      default:
        break;
    }
  };

  const getController = () => {
    switch (introspeccion) {
      case "1":
        return "TestParadigmas";
      case "2":
        return "EstiloAprendizaje";
      case "3":
        return "EstiloNaturalDecision";
      case "4":
        return "FactorCT";
      default:
        return "EstiloAprendizaje";
    }
  };

  const getFileName = (letrasMayores: string) => {
    if (letrasMayores && letrasMayores.length === 3)
      return `${letrasMayores[0].toUpperCase()}-${letrasMayores[1].toUpperCase()}-${letrasMayores[2].toUpperCase()}`;
    else return "";
  };
  // const pdfPath = `reports/factor-ct/Formato CT _ ${getFileName()}.pdf`;

  const downloadFactorCTPDFsAsZIP = async () => {
    try {
      const zip = new JSZip();
      const pdfPromises = [];
      // const pdfPath = `reports/factor-ct/Formato CT _ ${getFileName()}.pdf`;

      // Download all selected PDF files
      for (const k of selection) {
        const element: any = { ...rows.find((row) => row.id === k) };
        const pdfPath = `/reports/factor-ct/Formato CT _ ${getFileName(
          element.letrasMayores
        )}.pdf`;
        pdfPromises.push(fetch(pdfPath).then((response) => response.blob()));
        console.log(pdfPath);
      }

      // Wait for all PDFs to be downloaded
      const pdfBlobs = await Promise.all(pdfPromises);

      // Add all PDFs to the ZIP archive
      for (let i = 0; i < selection.length; i++) {
        const element = { ...rows.find((row) => row.id === selection[i]) };
        zip.file(
          `Factor CT(${element.nombreUsuario})-(${element.programa}).pdf`,
          pdfBlobs[i]
        );
      }

      // Generate the ZIP archive
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Create a download link for the ZIP file
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(zipBlob);
      downloadLink.download = "factorct.zip"; // Set the name of the ZIP file
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink); // Clean up after download
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const downloadFactorCTPDFsAsZIP = async () => {
  //   try {
  //     const zip = new JSZip();

  //     // Add each PDF file to the ZIP archive
  //     for (const k of selection) {
  //       const element: any = { ...rows.filter((l) => l.id == k)[0] };

  //       const pdfPath = `reports/factor-ct/${getFileName(
  //         element.letrasMayores
  //       )}.pdf`; // Assuming all PDFs are in the "reports/factor-ct/" directory
  //       const response = await fetch(pdfPath);
  //       const pdfData = await response.blob();
  //       zip.file(
  //         `Factor CT(${element.nombreUsuario})-(${element.programa}).pdf`,
  //         pdfData
  //       );
  //     }

  //     // Generate the ZIP archive
  //     const zipBlob = await zip.generateAsync({ type: "blob" });

  //     // Create a download link for the ZIP file
  //     const downloadLink = document.createElement("a");
  //     downloadLink.href = URL.createObjectURL(zipBlob);
  //     downloadLink.download = "factorct.zip"; // Set the name of the ZIP file
  //     document.body.appendChild(downloadLink);
  //     downloadLink.click();
  //     document.body.removeChild(downloadLink); // Clean up after download
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const getReport = () => {
    axios.get(
      `${EnpointsUrlBase}/${getController()}/GetReport?usuario=${usuario}&programa=${programaSelected}&fechaInicio=${fechaInicioToSend}&fechaFin=${fechaFinToSend}&currentPage=1&itemsByPage=10000&propertyToSort=Empresa&orderDirection=ASC&empresa=${empresaSelected}`,
      (res: any, data: any) => {
        if (res === 200) {
          setRows(
            data.map((k: any) => ({
              ...k,
            }))
          );
        }
        setLoading(false);
      }
    );
  };

  const downloadEstiloAprendizajePDFsAsZIP = async () => {
    setLoading(true);
    try {
      const zip = new JSZip();
      let errores = 0;

      for (const k of selection) {
        const element = rows.find((l) => l.id === k);
        if (!element) continue;

        const { idUsuario, nombreUsuario, empresa, emailUsuario, programa } = element;
        try {
          const response = await axios.service.get(
            `${EnpointsUrlBase}/EstiloAprendizaje/GenerarInforme?i=${idUsuario}&u=${nombreUsuario}&m=${emailUsuario}&e=${empresa}&p=${programa}`,
            {
              responseType: "blob",
              headers: { Accept: "application/pdf" },
            }
          );
          if (response.status === 200) {
            zip.file(
              `Estilo de Aprendizaje(${nombreUsuario})-(${programa}).pdf`,
              response.data
            );
          }
        } catch {
          errores++;
        }
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `EstiloAprendizaje-${programaSelected}-${empresaSelected}-${usuario}(${fechaInicioToSend}_${fechaFinToSend}).zip`
      );

      if (errores > 0) {
        alert(`Se completó la descarga, pero ${errores} archivo(s) no se pudieron generar.`);
      }
    } catch (error) {
      console.error("Error generando ZIP de Estilo de Aprendizaje:", error);
      alert("Ocurrió un error al generar el archivo ZIP.");
    } finally {
      setLoading(false);
    }
  };

  const downloadEstiloNaturalDecisionPDFsAsZIP = async () => {
    setLoading(true);
    try {
      const zip = new JSZip();
      let errores = 0;

      for (const k of selection) {
        const element = rows.find((l) => l.id === k);
        if (!element) continue;

        const { id, nombreUsuario, programa } = element;
        try {
          const response = await axios.service.get(
            `${EnpointsUrlBase}/EstiloNaturalDecision/GenerarInforme/${id}`,
            {
              responseType: "blob",
              headers: { Accept: "application/pdf" },
            }
          );
          if (response.status === 200) {
            zip.file(
              `Estilo Natural de Decisión(${nombreUsuario})-(${programa}).pdf`,
              response.data
            );
          }
        } catch {
          errores++;
        }
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `EstiloNaturalDecision-${programaSelected}-${empresaSelected}-${usuario}(${fechaInicioToSend}_${fechaFinToSend}).zip`
      );

      if (errores > 0) {
        alert(`Se completó la descarga, pero ${errores} archivo(s) no se pudieron generar.`);
      }
    } catch (error) {
      console.error("Error generando ZIP de Estilo Natural de Decisión:", error);
      alert("Ocurrió un error al generar el archivo ZIP.");
    } finally {
      setLoading(false);
    }
  };

  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [identificacionToDelete, setIdentificacionToDelete] =
    React.useState("");

  const [identificacionClickedToDelete, setIdentificacionClickedToDelete] =
    React.useState("");

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#eaeaea",
          backgroundImage: "url(../Images/header-fondo.jpg)",
          height: "100vh",
        }}
      >
        <AppBar
          style={{ backgroundImage: `url(${bg})` }}
          position="absolute"
          color="default"
          elevation={0}
          sx={{
            position: "relative",
            borderBottom: (t) => `1px solid ${t.palette.divider}`,
          }}
        >
          <Toolbar>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img
                style={{ height: "50px" }}
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoleft.svg`)
                    .default
                }
                alt=""
              />
              <img
                style={{ height: "50px" }}
                className="logoright"
                src={
                  require(`../../assets/images/estilo-aprendizaje/logos/1/logoright.svg`)
                    .default
                }
                alt=""
              />
            </div>
          </Toolbar>
        </AppBar>
        <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
          >
            <Typography
              component="h1"
              variant="h4"
              align="center"
              sx={{ mb: { xs: 3, md: 3 } }}
            >
              Administrador de Reportes
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <DatePicker
                    value={fechaInicio}
                    onChange={handleFechaInicio}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <DatePicker value={fechaFin} onChange={handleFechaFin} />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                  <InputLabel id="introspeccion-select-label">
                    Introspección
                  </InputLabel>
                  <Select
                    labelId="introspeccion-select-label"
                    id="introspeccion-select"
                    value={introspeccion}
                    label="Introspección"
                    onChange={handleIntrospeccionChange}
                  >
                    <MenuItem value={1} disabled>
                      Test de paradigmas
                    </MenuItem>
                    <MenuItem value={2}>Estilo de aprendizaje</MenuItem>
                    <MenuItem value={3}>Estilo natural de decisión</MenuItem>
                    <MenuItem value={4}>Factor CT</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="programa"
                  name="programa"
                  label="Programa"
                  fullWidth
                  autoComplete=""
                  variant="standard"
                  value={programaSelected}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setProgramaSelected(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="empresa"
                  name="empresa"
                  label="Empresa"
                  fullWidth
                  autoComplete=""
                  variant="standard"
                  value={empresaSelected}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setEmpresaSelected(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="usuario"
                  name="usuario"
                  label="Usuario"
                  fullWidth
                  autoComplete=""
                  variant="standard"
                  value={usuario}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUsuario(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    endIcon={<SearchIcon />}
                  >
                    Buscar
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <FormControl>
                  <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                    <Stack spacing={2} direction="row">
                      <Button
                        disabled={!(selection && selection.length > 0)}
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        variant="contained"
                        endIcon={<DownloadIcon />}
                      >
                        Exportar
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem onClick={downloadExcelFile}>
                          <ListItemIcon>
                            <LibraryBooksIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>Excel</ListItemText>
                        </MenuItem>

                        <MenuItem
                          onClick={downloadGraficosZip}
                          disabled={introspeccion == "4"}
                        >
                          <ListItemIcon>
                            <PhotoIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>Gráficos</ListItemText>
                        </MenuItem>

                        <MenuItem onClick={downloadPdfFiles}>
                          <ListItemIcon>
                            <PictureAsPdfIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>PDF</ListItemText>
                        </MenuItem>
                      </Menu>
                      <Button
                        disabled={!(selection && selection.length === 1)}
                        variant="contained"
                        color="error"
                        onClick={() => {
                          const element: any = rows.filter(
                            (l) => l.id === selection[0]
                          )[0].idUsuario;
                          setIdentificacionToDelete("");
                          setIdentificacionClickedToDelete(element);
                          setOpenModal(true);
                        }}
                        endIcon={<DeleteIcon />}
                      >
                        <span> Eliminar</span>
                      </Button>
                    </Stack>
                  </Box>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ height: 400, width: "100%" }}>
                  <DataGrid
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    density={"compact"}
                    rowSelectionModel={selection}
                    rows={rows}
                    columns={columns}
                    initialState={initialGridState}
                    pageSizeOptions={[5, 10, 15, 30, 50, 100]}
                    checkboxSelection
                    onRowSelectionModelChange={(
                      rowSelectionModel: GridRowSelectionModel
                    ) => {
                      setSelection(rowSelectionModel);
                    }}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Paper>
          <Copyright />
        </Container>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"¿Eliminar respuestas del usuario seleccionado?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Usted está a punto de eliminar las respuestas del usuario, si está
            seguro que desea hacerlo debe escribir el número de identidad del
            usuario y hacer clic en el botón eliminar. Estas respuestas no se
            podrán recuperar.
          </DialogContentText>
          <Grid item xs={12} sm={4} style={{ paddingTop: "10px" }}>
            <TextField
              disabled={loading}
              id="identificacion"
              name="identificacion"
              label="Identificación a eliminar"
              fullWidth
              autoComplete=""
              variant="standard"
              value={identificacionToDelete}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setIdentificacionToDelete(event.target.value);
              }}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancelar</Button>
          <Button
            disabled={
              !(identificacionClickedToDelete == identificacionToDelete) ||
              !identificacionClickedToDelete ||
              !identificacionToDelete ||
              loading
            }
            onClick={handleDelete}
            autoFocus
            color={"error"}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReportsContainer;
